import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  limit: 20,
  page: 1,
  total: 0,
  totalPages: 1,
};

export const contentPageSlice = createSlice({
  name: "contentPageSlice",
  initialState,
  reducers: {
    setContentPageLimit: (state, action) => {
      state.limit = action.payload;
    },
    setContentCurrentPage: (state, action) => {
      state.page = action.payload;
    },
    setContentTotalCount: (state, action) => {
      state.total = action.payload;
    },
    setContentTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    resetContentPagination: (state) => {
      state.limit = 20;
      state.page = 1;
      state.total = 0;
      state.totalPages = 1;
    },
  },
});

export const {
  setContentPageLimit,
  setContentCurrentPage,
  setContentTotalCount,
  setContentTotalPages,
  resetContentPagination,
} = contentPageSlice.actions;

export default contentPageSlice.reducer;
